/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ServeChatAttachmentSignedRequest = {
  /**
   * The signed JWT token
   */
  token: string;
};

export type ServeChatAttachmentSignedResponse = {
  headers: { [k: string]: Array<string> };
  result: ReadableStream<Uint8Array>;
};

/** @internal */
export type ServeChatAttachmentSignedRequest$Outbound = {
  token: string;
};

/** @internal */
export const ServeChatAttachmentSignedRequest$outboundSchema: z.ZodMiniType<
  ServeChatAttachmentSignedRequest$Outbound,
  ServeChatAttachmentSignedRequest
> = z.object({
  token: z.string(),
});

export function serveChatAttachmentSignedRequestToJSON(
  serveChatAttachmentSignedRequest: ServeChatAttachmentSignedRequest,
): string {
  return JSON.stringify(
    ServeChatAttachmentSignedRequest$outboundSchema.parse(
      serveChatAttachmentSignedRequest,
    ),
  );
}

/** @internal */
export const ServeChatAttachmentSignedResponse$inboundSchema: z.ZodMiniType<
  ServeChatAttachmentSignedResponse,
  unknown
> = z.pipe(
  z.object({
    Headers: z._default(z.record(z.string(), z.array(z.string())), {}),
    Result: z.custom<ReadableStream<Uint8Array>>(x =>
      x instanceof ReadableStream
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      "Headers": "headers",
      "Result": "result",
    });
  }),
);

export function serveChatAttachmentSignedResponseFromJSON(
  jsonString: string,
): SafeParseResult<ServeChatAttachmentSignedResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ServeChatAttachmentSignedResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ServeChatAttachmentSignedResponse' from JSON`,
  );
}
